// removed by extract-text-webpack-plugin
module.exports = {"l-grid":"_1hu-E","l-grid--half":"_1wW-G","grid--item":"_1y90-","template-404":"_1wEx7"};


//////////////////
// WEBPACK FOOTER
// ../assets/scss/main.scss
// module id = 773
// module chunks = 0